import React from "react";
import "./Introduction.css";
import { ThemeContext } from "../../Context/theme";
import profilePic from "../../assets/pic.png";


export const Introduction = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <section id="#about">
        <div className="section" data-aos="fade-right">
          <h2 className="section__title">
            About <span className="different">Me</span>
          </h2>
          <div className={"introduction " + themename}>
            <div className="introduction_logocontainer">
              <img src={profilePic} alt="Images" />
            </div>
            <div className="introduction_datacontainer">
              <h4>
                Hi Everyone, My name is{" "}
                <span className="different">Adith Pozhekadavil </span> and I am from{" "}
                <span className="different">
                  {" "}
                  Kerala, India
                </span>
                . I have completed my graduation in BTech (Computer Science & Engineering)
                from{" "}
                <span className="different">
                  APJAKTU, Kerala
                </span>

              </h4>
             
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
